import Vue from 'vue';

// App-wide event bus. Currently used for the navbar "Refresh USDT equal"
// button to tell whichever wallet page (or Dashboard) is mounted to re-run
// its own refreshPrices()/refresh() immediately, instead of waiting for its
// own 60s auto-refresh timer.
export default new Vue();
